import { formatTanggal } from "@/utils/dateFormate";
import { getStoredUserData } from "@/utils/getStoredUser";
import { getGreeting } from "@/utils/greeting";
import { Link } from "react-router-dom";
import { useRecentActivity } from "../hooks/useRecentActivity";
import LoadingSpinner from "@/components/fragments/LoadingSpinner";
// import { useRecentActivity } from "../hooks/useRecentActivity";

export default function HomeBase() {
  const userData = getStoredUserData();

  // const transactions = MockTransactionsActivity;
  const iconBgColors: string[] = ["#d7d0fe", "#ffecba", "#efecfa"];

  let nameCashier = userData?.emp_name ?? "Kasir";
  let greeting = getGreeting();

  const {
    data: transactions,
    isLoading,
    isError,
    error,
  } = useRecentActivity(userData?.email || "");

  return (
    <div className="p-4 md:p-6 ">
      {/* Salam pengguna */}
      <section className="flex items-center justify-between mb-8">
        <div>
          <h4 className="text-xl font-semibold tracking-tight text-gray-800 md:text-3xl dark:text-white">
            {greeting}, {nameCashier}
          </h4>
          <p className="text-base text-gray-500 dark:text-white">
            Welcome to
            <span className="underline dark:text-white decoration-wavy underline-offset-4 decoration-primary">
              Sellerku POS
            </span>
          </p>
        </div>
        <div>
          <Link to="/customer">
            <span className="text-xl font-bold">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="2em"
                height="2em"
                viewBox="0 0 32 32"
              >
                <g fill="none">
                  <path
                    fill="url(#SVGybQiheuV)"
                    d="M6 25h20.688S26 25.4 26 27s.688 2 .688 2H9a3 3 0 0 1-3-3z"
                  />
                  <path
                    fill="url(#SVG6upNGdOm)"
                    d="M9 28a2 2 0 0 1-2-2h18.25A1.75 1.75 0 0 0 27 24.25V6a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v20a4 4 0 0 0 4 4h17a1 1 0 1 0 0-2z"
                  />
                  <path
                    fill="url(#SVGATjivcFG)"
                    fill-opacity="0.3"
                    d="M9 28a2 2 0 0 1-2-2h18.25A1.75 1.75 0 0 0 27 24.25V6a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v20a4 4 0 0 0 4 4h17a1 1 0 1 0 0-2z"
                  />
                  <path
                    fill="url(#SVGsAvmNAKw)"
                    fill-opacity="0.3"
                    d="M9 28a2 2 0 0 1-2-2h18.25A1.75 1.75 0 0 0 27 24.25V6a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v20a4 4 0 0 0 4 4h17a1 1 0 1 0 0-2z"
                  />
                  <path
                    fill="url(#SVGyqoxZGBP)"
                    fill-opacity="0.9"
                    d="M19 10.5a3 3 0 1 1-6 0a3 3 0 0 1 6 0m2.5 6.75c0 1.868-1.571 3.75-5.5 3.75s-5.5-1.875-5.5-3.75v-.205c0-1.13.916-2.045 2.046-2.045h6.909c1.13 0 2.045.915 2.045 2.045z"
                  />
                  <defs>
                    <linearGradient
                      id="SVGybQiheuV"
                      x1="15.565"
                      x2="15.565"
                      y1="28.2"
                      y2="25"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#9deaff" />
                      <stop offset=".716" stop-color="#58aafe" />
                    </linearGradient>
                    <linearGradient
                      id="SVG6upNGdOm"
                      x1="12.828"
                      x2="17.084"
                      y1="7.239"
                      y2="37.41"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#20ac9d" />
                      <stop offset="1" stop-color="#2052cb" />
                    </linearGradient>
                    <linearGradient
                      id="SVGyqoxZGBP"
                      x1="24.255"
                      x2=".713"
                      y1="32.571"
                      y2="-2.607"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#9deaff" />
                      <stop offset="1" stop-color="#fff" />
                    </linearGradient>
                    <radialGradient
                      id="SVGATjivcFG"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(8.5 0 0 4.26316 16 18.5)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#171155" />
                      <stop offset="1" stop-color="#4a43cb" stop-opacity="0" />
                    </radialGradient>
                    <radialGradient
                      id="SVGsAvmNAKw"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(3.5 0 0 3.40447 17 10.5)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#171155" />
                      <stop offset="1" stop-color="#4a43cb" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </g>
              </svg>
            </span>
          </Link>
        </div>
      </section>

      <section>
        <div>
          <div className="flex space-x-3">
            <div className=" bg-linear-to-br from-[#b8abff] to-[#d7d0fe] w-full p-3 rounded-3xl flex flex-col items-stretch ">
              <div className="h-full rounded-xl">
                <div className=" w-12 h-12 bg-white rounded-full text-[#242529] flex justify-center items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="2em"
                    height="2em"
                    viewBox="0 0 24 24"
                  >
                    <g fill="none">
                      <path
                        fill="url(#SVG9IHubblY)"
                        d="M9 6a3 3 0 1 0 0 6a3 3 0 0 0 0-6"
                      />
                      <path
                        fill="url(#SVGblXDkbxq)"
                        d="M15 12a3 3 0 1 0 0 6a3 3 0 0 0 0-6"
                      />
                      <path
                        fill="url(#SVGYLxRieVT)"
                        d="M14 7a3 3 0 1 1 6 0a3 3 0 0 1-6 0"
                      />
                      <path
                        fill="url(#SVG7R1Yvc8m)"
                        d="M5 4a1 1 0 0 0-2 0v13.5A3.5 3.5 0 0 0 6.5 21H20a1 1 0 1 0 0-2H6.5A1.5 1.5 0 0 1 5 17.5z"
                      />
                      <defs>
                        <linearGradient
                          id="SVG9IHubblY"
                          x1="6.75"
                          x2="13.204"
                          y1="6.25"
                          y2="13.884"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#36dff1" />
                          <stop offset="1" stop-color="#0078d4" />
                        </linearGradient>
                        <linearGradient
                          id="SVGblXDkbxq"
                          x1="18"
                          x2="8.4"
                          y1="18"
                          y2="8.4"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#6d37cd" />
                          <stop offset=".641" stop-color="#ea71ef" />
                        </linearGradient>
                        <linearGradient
                          id="SVGYLxRieVT"
                          x1="19.5"
                          x2="15.2"
                          y1="8.9"
                          y2="4"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#e23cb4" />
                          <stop offset="1" stop-color="#ea71ef" />
                        </linearGradient>
                        <linearGradient
                          id="SVG7R1Yvc8m"
                          x1="19.313"
                          x2="3.56"
                          y1="4.125"
                          y2="27.58"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#70777d" />
                          <stop offset="1" stop-color="#b9c0c7" />
                        </linearGradient>
                      </defs>
                    </g>
                  </svg>
                </div>
              </div>
              <Link to={"/revenue"}>
                <div className="w-full h-full px-2 pt-2 mt-12 rounded-xl">
                  <h4 className=" text-[22px] md:text-3xl font-medium tracking-tight leading-tight text-[##242529]">
                    Lihat Pendapatan
                  </h4>
                  <p className="text-muted-foreground dark:text-[#1e1e1e]">
                    Periksa Sekarang
                  </p>
                </div>
              </Link>
            </div>
            <div className="flex flex-col w-full space-y-3">
              <Link to={"/customer/add"}>
                <div className="bg-linear-to-br from-[#ffdb7e] to-[#ffecba]  w-full p-2 rounded-3xl h-full flex flex-col relative">
                  <div className="bg-[#ff7075] px-3 py-1 rounded-full flex justify-center items-center absolute -top-2 right-2">
                    <p className="text-sm text-white">NEW</p>
                  </div>
                  <div className="h-full rounded-xl">
                    <div className=" w-12 h-12 bg-white rounded-full text-[#242529] flex justify-center items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="2em"
                        height="2em"
                        viewBox="0 0 20 20"
                      >
                        <g fill="none">
                          <path
                            fill="url(#SVGBCzPsVev)"
                            d="M1.5 12a2 2 0 0 1 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4s-5.25-4-5.25-4"
                          />
                          <path
                            fill="url(#SVG8jxfvbem)"
                            d="M1.5 12a2 2 0 0 1 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4s-5.25-4-5.25-4"
                          />
                          <path
                            fill="url(#SVGUa7eJdxW)"
                            fill-opacity="0.5"
                            d="M1.5 12a2 2 0 0 1 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4s-5.25-4-5.25-4"
                          />
                          <path
                            fill="url(#SVGjB0wGVFV)"
                            d="M14.5 9a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5"
                          />
                          <path
                            fill="url(#SVGdbVukc8U)"
                            d="M6.75 9a3.25 3.25 0 1 0 0-6.5a3.25 3.25 0 0 0 0 6.5"
                          />
                          <path
                            fill="url(#SVGVoDsPd0j)"
                            d="M19 14.5a4.5 4.5 0 1 0-9 0a4.5 4.5 0 0 0 9 0"
                          />
                          <path
                            fill="url(#SVG0gscZdUL)"
                            fill-rule="evenodd"
                            d="M14.5 12a.5.5 0 0 1 .5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5a.5.5 0 0 1 .5-.5"
                            clip-rule="evenodd"
                          />
                          <defs>
                            <linearGradient
                              id="SVGBCzPsVev"
                              x1="3.997"
                              x2="6.153"
                              y1="10.798"
                              y2="16.823"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop offset=".125" stop-color="#bd96ff" />
                              <stop offset="1" stop-color="#9c6cfe" />
                            </linearGradient>
                            <linearGradient
                              id="SVG8jxfvbem"
                              x1="6.75"
                              x2="9.79"
                              y1="9.286"
                              y2="19.225"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#885edb" stop-opacity="0" />
                              <stop offset="1" stop-color="#e362f8" />
                            </linearGradient>
                            <linearGradient
                              id="SVGjB0wGVFV"
                              x1="13.189"
                              x2="15.737"
                              y1="4.665"
                              y2="8.734"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop offset=".125" stop-color="#9c6cfe" />
                              <stop offset="1" stop-color="#7a41dc" />
                            </linearGradient>
                            <linearGradient
                              id="SVGdbVukc8U"
                              x1="5.046"
                              x2="8.358"
                              y1="3.364"
                              y2="8.654"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop offset=".125" stop-color="#bd96ff" />
                              <stop offset="1" stop-color="#9c6cfe" />
                            </linearGradient>
                            <linearGradient
                              id="SVGVoDsPd0j"
                              x1="10.321"
                              x2="16.532"
                              y1="11.688"
                              y2="18.141"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#52d17c" />
                              <stop offset="1" stop-color="#22918b" />
                            </linearGradient>
                            <linearGradient
                              id="SVG0gscZdUL"
                              x1="12.938"
                              x2="14.472"
                              y1="12.51"
                              y2="17.926"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#fff" />
                              <stop offset="1" stop-color="#e3ffd9" />
                            </linearGradient>
                            <radialGradient
                              id="SVGUa7eJdxW"
                              cx="0"
                              cy="0"
                              r="1"
                              gradientTransform="matrix(2 4.5 -4.5 2 12.5 14.5)"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#30116e" />
                              <stop
                                offset=".331"
                                stop-color="#30116e"
                                stop-opacity="0.812"
                              />
                              <stop
                                offset="1"
                                stop-color="#30116e"
                                stop-opacity="0"
                              />
                            </radialGradient>
                          </defs>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div className="w-full h-full p-2 mb-3 rounded-xl">
                    <h4 className=" text-[22px]  font-medium tracking-tight text-gray-800 ">
                      New Customer
                    </h4>
                  </div>
                </div>
              </Link>
              <Link to={"/barcode-scan"}>
                <div className=" bg-linear-to-br from-[#3c3e42] to-[#66696e] w-full p-2 rounded-3xl h-full flex flex-col ">
                  <div className="h-full rounded-xl">
                    <div className=" w-12 h-12 bg-white rounded-full text-[#242529] flex justify-center items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1.5em"
                        height="1.5em"
                        viewBox="0 0 16 16"
                      >
                        <g fill="none">
                          <path
                            fill="url(#SVGe0Oxyc4T)"
                            fill-rule="evenodd"
                            d="M3.5 3a.5.5 0 0 0-.5.5V5a1 1 0 0 1-2 0V3.5A2.5 2.5 0 0 1 3.5 1H5a1 1 0 0 1 0 2zM10 2a1 1 0 0 1 1-1h1.5A2.5 2.5 0 0 1 15 3.5V5a1 1 0 1 1-2 0V3.5a.5.5 0 0 0-.5-.5H11a1 1 0 0 1-1-1m-8 8a1 1 0 0 1 1 1v1.5a.5.5 0 0 0 .5.5H5a1 1 0 1 1 0 2H3.5A2.5 2.5 0 0 1 1 12.5V11a1 1 0 0 1 1-1m12 0a1 1 0 0 1 1 1v1.5a2.5 2.5 0 0 1-2.5 2.5H11a1 1 0 1 1 0-2h1.5a.5.5 0 0 0 .5-.5V11a1 1 0 0 1 1-1"
                            clip-rule="evenodd"
                          />
                          <path
                            fill="url(#SVGw5NivcNQ)"
                            d="M8 10a2 2 0 1 0 0-4a2 2 0 0 0 0 4M5.25 6a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5"
                          />
                          <defs>
                            <radialGradient
                              id="SVGw5NivcNQ"
                              cx="0"
                              cy="0"
                              r="1"
                              gradientTransform="rotate(48.013 -3.486 9.92)scale(4.62468 3.96083)"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#0fafff" />
                              <stop offset="1" stop-color="#2052cb" />
                            </radialGradient>
                            <linearGradient
                              id="SVGe0Oxyc4T"
                              x1=".447"
                              x2="11.425"
                              y1="-.172"
                              y2="17.561"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop offset=".015" stop-color="#3dcbff" />
                              <stop offset="1" stop-color="#0094f0" />
                            </linearGradient>
                          </defs>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div className="w-full h-full p-2 mb-3 rounded-xl">
                    <h4 className=" text-[22px]  font-medium tracking-tight text-white leading-tight">
                      Scan BarCode
                    </h4>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="mt-10">
          <div className="flex justify-between">
            <h3 className="text-xl font-semibold text-[#1e1e1e] dark:text-white mb-2">
              Transaksi Terakhir
            </h3>
            <Link to="/activity">
              <span className="underline decoration-wavy underline-offset-4 decoration-[#1e1e1e] dark:text-white dark:decoration-primary ">
                Show All
              </span>
            </Link>
          </div>
          <div className="space-y-2">
            {isLoading && (
              <div className="flex flex-col items-center justify-center w-full min-h-25">
                <LoadingSpinner />
                <p className="mt-2 text-sm text-gray-600 dark:text-white">
                  Loading...
                </p>
              </div>
            )}

            {isError && (
              <div className="flex items-center justify-center w-full p-4 rounded min-h-25 bg-red-50">
                <p className="text-sm text-red-600">
                  {error instanceof Error
                    ? `Error: ${error.message}`
                    : "Terjadi kesalahan"}
                </p>
              </div>
            )}

            {!isLoading &&
              !isError &&
              transactions &&
              transactions.length == 0 && (
                <div className="flex items-center justify-center w-full p-4 rounded min-h-25 bg-red-50">
                  <p className="text-[#1e1e1e] dark:text-white text-sm">
                    Tidak ada transaksi
                  </p>
                </div>
              )}

            {!isLoading &&
              !isError &&
              transactions &&
              transactions.map((item, index) => (
                <div
                  key={`${item.out_no} ${index}`}
                  className="rounded-full p-1.5 bg-[#f9f8fd] dark:bg-[#1e1e1e] hover:bg-white dark:hover:bg-transparent  hover:scale-105 transition-all cursor-pointer duration-200"
                >
                  <div className="flex items-center">
                    {/* Icon */}
                    <div className="mr-3">
                      <div
                        className="flex items-center justify-center w-12 h-12 transition-colors rounded-full"
                        style={{
                          backgroundColor:
                            iconBgColors[index % iconBgColors.length],
                        }}
                      >
                        <span
                          className="text-2xl font-bold"
                          style={{ color: item.iconColor }}
                        >
                          ⌘
                        </span>
                      </div>
                    </div>

                    {/* Text */}
                    <div className="flex-1">
                      <p className="font-medium text-foreground dark:text-white">
                        {item.cust_name == "Default" ? "Umum" : item.cust_name}
                      </p>
                      <p className="text-xs font-light text-foreground dark:text-white">
                        {formatTanggal(String(item.out_date))}
                      </p>
                    </div>

                    {/* Action Icon */}
                    <div className="ml-3">
                      <div className="flex items-center justify-center w-12 h-12 rounded-full">
                        <span className="text-xl font-bold text-foreground dark:text-white">
                          ∘∘∘
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>
    </div>
  );
}
